<template>
  <sweet-modal ref="modal" overlay-theme="dark" :enable-mobile-fullscreen="false">
    <div class="row" v-if="professional">
      <div class="col-12 text-left">
        <div>
          <label>{{ $t('message.booking.new_booking.choose_a_service') }}</label>
        </div>
        <a :href="`/cleaner/${professional.id}?sid=${service.id}`"
          target="_blank"
          class="text-dark"
          @click="closeModal()"
          v-for="service in professional.services"
          v-if="service.id != 13">
          <div class="card">
            <div class="card-body">
              {{ service | multiLangName }}
            </div>
          </div>
        </a>
        <a :href="`/special-services/${experience.id}`"
          target="_blank"
          class="text-dark"
          @click="closeModal()"
          v-for="experience in professional.experiences">
          <div class="card">
            <div class="card-body">
              {{ experience.title }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'

  export default {
    components: {
      SweetModal
    },
    data () {
      return {
        professional: null
      }
    },
    computed: {
      imageUrl () {
        return (this.$i18n.locale === 'en')
          ? '/static/img/dialog_instant_booking_en.png'
          : '/static/img/dialog_instant_booking_th.png'
      }
    },
    methods: {
      setProfessional (professional) {
        this.professional = professional
        this.openModal()
      },
      openModal () {
        this.$refs.modal.open()
      },
      closeModal () {
        this.$refs.modal.close()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/ProfessionalServiceModal.vue